<template>
    <v-dialog
            :value="!!value"
            :retain-focus="false"
            persistent
            max-width="800"
    >
        <v-form
                v-model="validForm"
                ref="form"
                @submit.prevent="submit"
        >
            <v-card
                    :loading="loading > 0"
                    :disabled="loading > 0"
            >
                <v-card-title class="grs-card-title px-0">
                    <span> {{ $t('ticket_form_title') }} </span>

                    <v-spacer></v-spacer>

                    <v-btn
                            text
                            small
                            icon
                            @click="$emit('close')"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pb-0">
                    <v-text-field
                            v-model="value.subject"
                            :label="$t('subject')"
                            :rules="[rules.required]"
                    ></v-text-field>
                    <v-select
                            :items="ticketDepartment"
                            v-model="value.department"
                            :label="$t('department')"
                            item-text="value"
                            item-value="key"
                    ></v-select>
                    <UserSelect
                        clearable
                        v-model="value.user_id"
                        :label="$t('user')"
                        placeholder="نام و نام خانوادگی  یا شماره همراه"
                        className="ml-5"
                    ></UserSelect>
                    <v-textarea
                            v-model="value.description"
                            :label="$t('description')"
                            :rules="[rules.required]"
                    ></v-textarea>
                </v-card-text>

                <v-card-actions class="px-4 pb-4">
                    <v-spacer></v-spacer>

                    <v-btn
                            color="secondary"
                            text
                            class="px-4"
                            @click="$emit('close')"
                    >{{$t('cancel')}}</v-btn>

                    <v-btn
                            color="primary"
                            class="px-4"
                            type="submit"
                    >
                        {{$t('send_request')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
    import {required} from '@/scripts/validationRules';
    import Service from "../services/TicketService";
    import UserSelect from '../components/UserSelect'

    export default {
        components : {
            UserSelect
        },
        props: {
            item : {
                required: true
            }
        },
        computed : {
            ticketDepartment(){
                return Object.keys(this.$t("ticket_department")).map(key => {
                    return {
                        key,
                        value: this.$t("ticket_department")[key]
                    }
                });
            }
        },
        data() {
            return {
                validForm: false,
                loading: 0,
                value : {...this.item},
                rules: {
                    required
                },

            }
        },
        methods: {
            async submit() {
                if(!this.validForm) {
                    return this.$refs.form.validate();
                }

                try {
                    this.loading++;

                    let {
                        data
                    } = await Service.create(this.value);
                    this.$emit('submit', data);

                    this.$notify({
                        group: 'formGroup',
                        type: 'success',
                        title: data.message,
                    });

                } finally {
                    this.loading--;
                }

                this.$emit('close');
            }
        }
    }
</script>